import React from 'react';

import BlockRuleKeyValueBuilder from '@components/block-event-single/components/BlockRuleKeyValueBuilder';
import { IBlockRuleRow } from '@components/block-event-single/components/BlockRuleRow/typed';
import {
  BlockRuleTypeOptions,
  EVENT_NAME_WITH_BLOCK_RULE,
} from '@components/block-event-single/constant/constant';
import { EPanelOpenMethod } from '@components/block-event-single/store';
import LogicSelector from '@components/common/LogicSelector';
import { Icon } from '@components/metrics-builder/components/MetricList';
import DeleteActiveSvg from '@icons/mapping-panel/delete-active-icon.svg';
import DeleteSvg from '@icons/mapping-panel/delete-icon.svg';

import { BlockRuleName, BlockRuleRowWrapper, BlockTypeSelect, DeleteButtonWrapper } from './styled';

const BlockRuleRow: React.FC<IBlockRuleRow> = ({
  mode,
  index,
  eventName,
  data,
  blockType,
  onChange,
  onBlockTypeChange,
  onDelete,
  blockRules,
}) => {
  const isFirst = index === 0;
  const isBlockIf = blockType === BlockRuleTypeOptions[1].value;
  const isOnlyBlockAll =
    typeof eventName === 'undefined' || !EVENT_NAME_WITH_BLOCK_RULE.includes(eventName);

  if (!isFirst && !isBlockIf) {
    return null;
  }

  return (
    <BlockRuleRowWrapper>
      {isFirst || isOnlyBlockAll ? (
        <>
          <BlockRuleName>Block Rule:</BlockRuleName>
          <BlockTypeSelect
            defaultValue={BlockRuleTypeOptions[0].value}
            value={blockType}
            options={BlockRuleTypeOptions}
            onChange={(value) => {
              onBlockTypeChange?.(value);
            }}
            dropdownStyle={{
              minWidth: 'fit-content',
            }}
            disabled={isOnlyBlockAll || mode === EPanelOpenMethod.VIEW}
            dropdownRender={(originNode) => (
              <div data-test-id={`block_type_dropdown`}>{originNode}</div>
            )}
          />
        </>
      ) : (
        <>
          <div style={{ width: '132px' }} />
          <LogicSelector />
        </>
      )}
      {!isOnlyBlockAll && isBlockIf && (
        <>
          <BlockRuleKeyValueBuilder
            mode={mode}
            eventName={eventName}
            data={data}
            blockRules={blockRules}
            onChange={onChange}
          />
          {mode !== EPanelOpenMethod.VIEW && (
            <DeleteButtonWrapper>
              <Icon
                component={DeleteSvg}
                activeComponent={DeleteActiveSvg}
                onClick={() => {
                  onDelete?.();
                }}
              />
            </DeleteButtonWrapper>
          )}
        </>
      )}
    </BlockRuleRowWrapper>
  );
};

export default BlockRuleRow;
